import { DateTime } from 'luxon';
import { ShDatepickerElement } from '../types/sh-datepicker-element.type';

const SHUI_TO_LUXON_TOKENS: Record<string, string> = {
    YYYY: 'yyyy',
    MMM: 'LLL',
    MM: 'MM',
    DD: 'dd',
    M: 'L',
    D: 'd'
};

export function formatShDatepickerValue(date: Date, element: ShDatepickerElement): string {
    const separator = element.separator ?? '/';
    const format = element.format ?? 'MMDDYYYY';
    const tokens = format.match(/YYYY|MMM|MM|DD|M|D/g) ?? ['MM', 'DD', 'YYYY'];
    const luxonFormat = tokens.map(token => SHUI_TO_LUXON_TOKENS[token]).join(separator);

    return DateTime.fromJSDate(date)
        .setLocale(element.locale ?? 'en')
        .toFormat(luxonFormat);
}
